import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Progress, Row, Spin, Upload } from "antd";
import axios from "axios";
import { axiosErrorHandler, displayImageUploadErrorMessage, showErrorNotification } from "../../../../../swzutils";
import { validateGreaterThanZero } from "../../../../../swzutils/ValidationUtil";
import { FileTextOutlined } from "@ant-design/icons";
import { IMG_UPLOAD_ACCEPTS } from "../../../../../constants/HTML";
import { EditMode } from "../../../enums/EditMode";
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../../../../../API";
const VehicleHireDocketForm = ({ mode, vehicleHireId, docketId }) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [showSpinner, setShowSpinner] = useState(false);
    const [editDocket, setEditDocket] = useState(undefined);
    const [photo, setPhoto] = useState({});
    const [searchParams] = useSearchParams();
    useEffect(() => {
        if (mode == EditMode.EDIT && vehicleHireId && docketId) {
            loadDocket();
        }
    }, [mode, vehicleHireId, docketId]);
    const loadDocket = () => {
        setShowSpinner(true);
        axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}/dockets/${docketId}`).then(response => {
            const docket = response.data;
            form.setFieldsValue({
                "comments": docket.comments,
                "netQty": docket.net
            });
            setEditDocket(docket);
            setPhoto({
                "contentsUri": `/admin/v1/vehicle-hires/${vehicleHireId}/dockets/${docketId}/image`
            });
        }).finally(() => setShowSpinner(false));
    };
    const onFinish = (formValues) => {
        if (mode === EditMode.CREATE && !photo.uploadedFileId) {
            showErrorNotification("Please upload a photo of the docket.");
            return;
        }
        onSave(formValues);
    };
    const onSave = (formValues) => {
        let saveUri = `/admin/v1/vehicle-hires/${vehicleHireId}/dockets`;
        let saveMethod = "post";
        if (mode === EditMode.EDIT && docketId) {
            saveUri += `/${docketId}`;
            saveMethod = "put";
        }
        axios(saveUri, {
            method: saveMethod,
            data: {
                "version": editDocket ? editDocket.version : undefined,
                "fileUploadId": photo.uploadedFileId,
                "comments": formValues.comments,
                "net": formValues.netQty
            }
        })
            .then(( /*response*/) => back())
            .catch(axiosErrorHandler)
            .finally(() => setShowSpinner(false));
    };
    const back = () => {
        const backURL = searchParams.get("backUrl");
        if (backURL) {
            navigate(backURL);
        }
        else {
            navigate(`/app/vehicle-hires/edit/${vehicleHireId}`);
        }
    };
    return (_jsx(Spin, { spinning: showSpinner, children: _jsx(Form, { layout: "vertical", onFinish: onFinish, form: form, children: _jsxs(Row, { gutter: 8, className: "no-margin", children: [" ", _jsx(Col, { sm: 24, md: 16, lg: 20, children: _jsxs(Upload.Dragger, { name: "uploadFile", accept: IMG_UPLOAD_ACCEPTS, withCredentials: true, showUploadList: false, action: `${API.origin()}/admin/v1/files?mandateImage=true`, onChange: (info) => {
                                const status = info.file.status;
                                if (status === 'uploading') {
                                    setPhoto({ uploadProgress: info.file.percent });
                                }
                                if (status === 'done') {
                                    const response = info.file.response;
                                    setPhoto({
                                        uploadProgress: undefined,
                                        contentsUri: response.contentsUri,
                                        deleteUri: response.deleteUri,
                                        uploadedFileId: response.id
                                    });
                                }
                                else if (status === 'error') {
                                    setPhoto({ uploadProgress: undefined });
                                    displayImageUploadErrorMessage(info.file);
                                }
                            }, children: [photo.contentsUri ?
                                    _jsx("img", { src: `${API.origin()}${photo.contentsUri}`, alt: "", className: "img-fluid" })
                                    :
                                        _jsx("p", { className: "ant-upload-drag-icon", children: _jsx(FileTextOutlined, {}) }), photo.uploadProgress ?
                                    _jsx(Progress, { percent: photo.uploadProgress, status: "active" })
                                    :
                                        _jsxs("div", { className: "upload-instructions", children: [_jsx("p", { className: "ant-upload-text", children: "Click or drag an image of the docket in to this area to upload." }), _jsx("p", { className: "ant-upload-hint", children: "Only png, gif or jpg files are supported" })] })] }) }), _jsxs(Col, { sm: 24, md: 8, lg: 4, children: [_jsx(Form.Item, { name: "netQty", label: "Net", rules: [
                                    { required: true, message: "Net is required" },
                                    { validator: validateGreaterThanZero }
                                ], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "comments", label: "Comments", children: _jsx(Input.TextArea, { rows: 5 }) }), _jsxs(Row, { gutter: 10, children: [_jsx(Col, { xs: 12, children: _jsx(Button, { block: true, type: "primary", htmlType: "submit", size: "large", children: "Save" }) }), _jsx(Col, { xs: 12, children: _jsx(Button, { block: true, type: "default", htmlType: "button", size: "large", onClick: back, children: "Cancel" }) })] })] })] }) }) }));
};
export default VehicleHireDocketForm;
